// extracted by css-extract-rspack-plugin
export default {"box":"OfficeSelectorField__box--eVZnl"};